export const reportingUrlv2 = process.env.REACT_APP_REPORTING_V2_API_URL || "/api-reporting-v2";
